import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Radio, Spin, Tabs, Table } from 'antd';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import DataType from "../../../../Functions/Traitement/DataPeriodMVirement";
import { ColumnsType } from "antd/es/table";
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import InputForm from "../../../InputT";


const VisualVp = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")


    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        //sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))
        //consult();
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }

    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);
    const [SearchR, SetSearchR] = useState<string>("");

    //column du tableau
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro dossier',
            dataIndex: 'NUMDOS',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMDOS)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.CPTDEB)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.CPTCRE)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Compte débit',
            dataIndex: 'CPTDEB',
        },
        {
            title: 'Compte crédit',
            dataIndex: 'CPTCRE',
        },
        {
            title: 'Montant',
            dataIndex: 'MONTAN',
        },
        {
            title: 'Status',
            dataIndex: 'cdetat',
        },
        {
            title: 'Crée par',
            dataIndex: 'UTISAI',
        },
        {
            title: 'Agence',
            dataIndex: 'codage',
        }, {
            title: 'Crée la',
            dataIndex: 'DATSAI',
        }, {
            title: 'Date imputation',
            dataIndex: 'DATIMP',
        }, {
            title: 'Date arrêt imput',
            dataIndex: 'DATARRIMP',
        }, {
            title: 'Fréquence',
            dataIndex: 'FREQIMP',
        },
        //STACHQ

    ];

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Visualisation des virements permanent
                </span>
            ),
            children: <Tab1 />,
        },
    ];


    // function consult 
    function consult() {

    }

    // function consult tableableau
    function Consultableau() {
        setSelectedRowKeys([]);
        let a = Perss.codage;


        if (form.getFieldValue("ETAT") == null) {
            SweetAlert.fire({ text: "Préciser l'état SVP", icon: "warning" })
        } else {
            let b = form.getFieldValue("ETAT");
            setLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AllVirementPerme,
                headers: {
                    'CypherCodeage': Crypter.encrypt(a),
                    'CypherTrie': Crypter.encrypt(b),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json',
                },
            };

            // MAPPING DANS LE TABLEAU
            let dat: DataType[] = [];
            axios.request(config)
                .then((response) => {
                    setLoading(false);

                    if (response.data) {
                        let datas = JSON.parse(JSON.stringify((response.data.Result?.Table || [])));
                        if (datas[0] == null) {
                            SweetAlert.fire({ title: "Il ne possède pas de Vp dans cette état", icon: "warning" })
                        } else {

                        }

                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                NUMDOS: val.NUMDOS,
                                CODOPE: val.CODOPE,
                                DATSAI: val.DATSAI,
                                DATIMP: val.DATIMP,
                                CPTDEB: val.CPTDEB,
                                LIBCPTDEB: val.LIBCPTDEB,
                                CPTCRE: val.CPTCRE,
                                LIBCPTCRE: val.LIBCPTCRE,
                                MONTAN: val.MONTAN,
                                FREQIMP: val.FREQIMP,
                                NBRIMP: val.NBRIMP,
                                DECOUV: val.DECOUV,
                                DATARRIMP: val.DATARRIMP,
                                UTISAI: val.UTISAI,
                                UTIMOD: val.UTIMOD,
                                DATMOD: val.DATMOD,
                                IsFRAIS: val.IsFRAIS,
                                MONTAN1: val.MONTAN1,
                                MONTAN2: val.MONTAN2,
                                MONTAN3: val.MONTAN3,
                                MONTAN4: val.MONTAN4,
                                LIBELL1: val.LIBELL1,
                                LIBELL2: val.LIBELL2,
                                LIBELL3: val.LIBELL3,
                                LIBELL4: val.LIBELL4,
                                CODOP1: val.CODOP1,
                                CODOP2: val.CODOP2,
                                CODOP3: val.CODOP3,
                                CODOP4: val.CODOP4,
                                codage: val.codage,
                                cdetat: val.cdetat,
                                utival: val.utival,
                                isbloqAuto: val.isbloqAuto,
                                datval: val.datval

                            })
                        })
                        setData((dat))
                    } else {
                        SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
        }


    }


    // function Onfinish
    const onFinish = (values: any) => {


    }



    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };



    return (<div className='tab'>
        <Typography align='center' className='formTitle'> <b>  {window.location.pathname} </b> </Typography>
        <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
            <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                <div className='bG'>
                    <legend><Typography color={"#116599"}>Actions</Typography></legend>
                    <Form.Item shouldUpdate className='bouttong'>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                Afficher
                            </Button>
                            <Button size='large' className='bt_add' disabled={false} onClick={() => { form.resetFields() }} type="ghost" block  >
                                Actualiser
                            </Button>
                        </Space>
                    </Form.Item>
                </div>
                <div className='clientP'>
                    <div>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>

                        <div className='tabItem' >

                            <div style={{ display: 'block flow' }}  >
                                <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                                    <legend> Visualisation des virements permanent </legend>
                                     <Box style={{ display: 'flex' }} fontStyle="inherit" className='border' width={"100%"} sx={{mb:1, p: 1}} >
                                        {/* <Box fontStyle="inherit" className='border'  width={"100%"}  sx={{mb:1}}> */}
                                            <Form.Item name={"ETAT"} style={{ marginLeft: '1%', display: "flex", marginTop: -20, width:'50%' }}>
                                                
                                                    <Radio.Group disabled={false}  
                                                    onChange={(e) => {
                                                      // Gère le changement ici
                                                      console.log("Radio selected:", e.target.value);
                                                                     }}
                                                            >
                                                    <Radio value={"1"} style={{ fontWeight: "bold" }}> {"En Attentes"}</Radio>
                                                    <Radio value={"2"} style={{ fontWeight: "bold" }}> {"Validés"}</Radio>
                                                    <Radio value={"3"} style={{ fontWeight: "bold" }}> {"Rejetés"}</Radio>
                                                    <Radio value={"4"} style={{ fontWeight: "bold" }}> {"Cloturés"}</Radio>
                                                    <Radio value={"5"} style={{ fontWeight: "bold" }}> {"Bloqués"}</Radio>
                                                    </Radio.Group>
                                              </Form.Item >
                                        {/* </Box> */}
                                      </Box>
                                    
                                            <Box fontStyle="inherit" className='border'  width={"100%"}  sx={{mb:1}}>
                                                <InputForm disabled={false} notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string" />
                                            </Box>
                                           
                                       <Box  fontStyle="inherit" className='border'  width={"100%"} sx={{mb:1}}>
                                            <Spin spinning={loading}>
                                                <Table dataSource={donnees} columns={columns} style={{ textAlign: "center", width: '100%' }} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                            </Spin>
                                        </Box>
                                   
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </Spin>
    </div>
    );

}

export default VisualVp;